import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Breadcrumb, Spin, message } from 'antd';
import FieldMap from '../components/map/FieldMap';
import InfoCard from '../components/environmental/InfoCard';
import { getDatastreamByID } from '../data/FrostApi';
import DatastreamsObservations from '../components/environmental/DatastreamsObservations';

function EnvironmentalMonitoringProduct() {
    const { datastreamID } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await getDatastreamByID(datastreamID);
                if (response) {
                    setData(response);
                } else {
                    message.error("No data found for the given datastream ID.");
                }
            } catch (error) {
                console.error("Error during data fetching:", error);
                message.error(error.message || "Failed to fetch data.");
            } finally {
                setLoading(false);
            }
        };

        if (datastreamID) {
            fetchData();
        } else {
            message.error("Datastream ID is not provided.");
        }

        // Clean up loading state if component unmounts
        return () => setLoading(false);
    }, [datastreamID]);


    return (
        <>
            <Spin spinning={loading} size="large">
                <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                    <h1 style={{ color: '#102F10' }}>
                        <Breadcrumb
                            items={[
                                {
                                    title: <a href="/">Home</a>,
                                },
                                {
                                    title: 'Datastream',
                                },
                                {
                                    title: data?.name,
                                },
                            ]}
                        />
                    </h1>
                </div>

                <Row gutter={[32, 24]}>
                    <Col span={12} xs={24} xl={12}>
                        <InfoCard data={data} title={'Datastream Information'} />
                        <DatastreamsObservations data={data} />
                    </Col>
                    <Col span={12} xs={24} xl={12}>
                        <div>
                            <FieldMap data={data?.observedArea} />
                        </div>
                    </Col>                
                </Row> 
            </Spin>           
        </>
    );
}

export default EnvironmentalMonitoringProduct;
